import { render, staticRenderFns } from "./ElraReport8.vue?vue&type=template&id=249b38b7"
import script from "./ElraReport8.vue?vue&type=script&lang=ts"
export * from "./ElraReport8.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8.vue?vue&type=style&index=0&id=249b38b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports